import React from "react";
import {Route, useLocation} from "react-router-dom";
import TopSection from "./TopSection";
import NewMenuBar from "./NewMenuBar";
import Dashboard from "./Dashboard";
import BooksPage from "../Books/BooksPage";
import ABookPage from "../Books/ABookPage";
import ABookListPage from "../Books/ABookListPage";
import AlterBooks from "../Books/AlterBooks";
import ReadBookPDF from "../Books/ReadBookPDF";
import CreateBookPage from "../Books/CreateBook/CreateBookPage";
import CreateBookListPage from "../Books/CreateBook/CreateBookListPage";
import EditBook from "../Books/CreateBook/EditBook";
import EditMetaDataL from "../Books/CreateBook/EditMetaDataL";
import EditProfilePage from "../UserIdentification/EditProfilePage";
import BookLists from "../Books/BookLists";
import AllOptionsPage from "../Books/AllOptionsPage";

const MainController = () => {
    let location = useLocation();
    let path = location.pathname;
    return(
        <div className="bg-grey">
            <Route path="/main" component={TopSection} />
            <div className="dekho"></div>
            <div className="mainController">
                <NewMenuBar url={path}/>
                <div className="menu_bar_contents">
                    <div className="menu_bar_content">
                        <Route path="/main/" exact component={Dashboard}/>
                        <Route path="/main/books" exact component={BooksPage}/>
                        <Route path="/main/books/:bookId" exact component={ABookPage}/>
                        <Route path="/main/bookLists/:bookId" exact component={ABookListPage}/>
                        <Route path="/main/books/readBookPDF/:bookId" exact component={ReadBookPDF}/>
                        <Route path="/main/bookLists" exact component={BookLists}/>
                        <Route path="/main/allOptions" exact component={AllOptionsPage}/>
                        <Route path="/main/createBook" exact component={CreateBookPage}/>
                        <Route path="/main/createBookList" exact component={CreateBookListPage}/>
                        <Route path="/main/editProfile" exact component={EditProfilePage}/>
                        <Route path="/main/editBook/PDF/:bookId" exact component={EditBook}/>
                        <Route path="/main/editBookL/:bookId" exact component={EditMetaDataL}/>
                        <Route path="/main/alterBooks/:bookId" exact component={AlterBooks}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainController;